import { StyleSheet, Platform } from 'react-native';
import { theme } from '../../../theme';
import { TUTORIAL_SLIDE_BACKGROUND_FALLBACK } from '../../../constants/tutorial.constants';

/** Full-screen shell sizes: use `getTutorialLayoutStyles` from `../helpers/tutorialLayoutStyles.helper`. */
export const tutorialStyles = StyleSheet.create({
  slide: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'center',
    paddingHorizontal: 20,
    backgroundColor: TUTORIAL_SLIDE_BACKGROUND_FALLBACK,
  },
  slideBackgroundFallback: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: TUTORIAL_SLIDE_BACKGROUND_FALLBACK,
    zIndex: 0,
  },
  slideContent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingHorizontal: 8,
    minHeight: 0,
    zIndex: 1,
  },
  bottomActions: {
    width: '100%',
    alignItems: 'center',
    flexShrink: 0,
    paddingHorizontal: 8,
    zIndex: 1,
  },
  /** Base skip control; `top` comes from getTutorialDynamicStyles */
  skipButtonAbsolute: {
    position: 'absolute',
    right: 16,
    backgroundColor: 'rgba(15, 10, 26, 0.72)',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.28)',
    borderRadius: 20,
    paddingVertical: 10,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  skipButtonPressed: {
    opacity: 0.82,
  },
  skipButtonHoveredWeb: {
    backgroundColor: 'rgba(255, 255, 255, 0.18)',
  },
  skipButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: theme.white,
  },
  primaryButton: {
    backgroundColor: '#A78BFA',
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 20,
    minHeight: Platform.OS === 'android' ? 50 : 48,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 400,
    alignSelf: 'center',
    flexShrink: 0,
  },
  primaryButtonPressed: {
    opacity: 0.92,
    transform: [{ scale: 0.97 }],
  },
  primaryButtonHoveredWeb: {
    backgroundColor: '#b9a3fb',
  },
  primaryButtonText: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111827',
    textAlign: 'center',
  },
  paginationContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 14,
    gap: 7,
  },
  paginationDot: {
    width: 7,
    height: 7,
    borderRadius: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.28)',
  },
  paginationDotActive: {
    backgroundColor: '#A78BFA',
    width: 22,
  },
  guestLinkText: {
    fontSize: 14,
    fontWeight: '600',
    color: 'rgba(255, 255, 255, 0.72)',
    textAlign: 'center',
    marginTop: 14,
  },
  guestLinkPressed: {
    opacity: 0.75,
  },
});
